<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="tips"
      @load="getList"
    >
      <div v-for="(item,index) in list" :key="index" class="data">
        <div class="hd">
          {{ item.treatmentHospital }}/{{ item.department }}
          <div class="time">{{ dateFormat(item.treatmentTime, 'YY-MM-DD hh:mm') }}</div>
        </div>
        <div class="bd">
          <div>诊断分析：{{ item.casePicture }}</div>
        </div>
      </div>
    </van-list>

  </div>
</template>

<script>
import { dateFormat } from '@/utils/tool'
import { fetchReports } from '@/api/health'

export default {
  data() {
    return {
      dateFormat,
      tips: '',
      loading: false,
      finished: false,
      list: [],
      listQuery: {
        page: 1,
        row: 20
      }
    }
  },
  created() {
  },
  methods: {
    getList(date) {
      fetchReports(this.listQuery).then(res => {
        this.loading = false
        const list = res.data.data
        if (this.listQuery.page === 1) {
          this.list = list
        } else {
          this.list.concat(list)
        }
        this.page++
        this.finished = list.length <= 20
        this.tips = this.list.length ? this.$t('viewBase.a46') : this.$t('viewBase.a47')
      })
    }

  }
}
</script>

<style scoped lang="scss">
  .data {
      background: #fff;
      margin-top: 10px;
      padding: 12px 15px;
  }
  .hd {
      display: flex;
      justify-content: space-between;
      .time {
          color: #999;
          font-size: 12px;
      }
  }
  .bd {
      color: #666;
      margin-top: 5px;
  }

</style>
